import "../../styles/Banners.css";
import "../../styles/Containers.css";
import "../../styles/Recipe.css";
import TopNavbar from "../../components/TopNavbar";
import Navbar from "../../components/Navbar";
import { Link } from "react-router-dom";
import GoToTop from "../../components/GoToTop";
import Slider from "./components/Slider";
import FFF from "../../media/FFF.png";
import NinjaBanner from "../ninja/components/NinjaBanner";
import { ReactComponent as NinjaEmoji } from "../../../src/media/emoji/ninjaEmoji.svg";
import { useState } from "react";
import NinjaModal from "../ninja/components/NinjaModal";
import DietBanner from "../diet/components/DietBanner";
import CategoryItem from "./components/CategoryItem";
import DietItem from "./components/DietItem";
import ChallengeBanner from "../challenges/components/ChallengeBanner";

export default function Home() {
  // const tags1 = ["صبحانه،", "نهار،", "شام،", "میانوعده‌ها"];
  const slides = [
    {
      image: "/images/image-1.jpg",
      alt: "اسموتی",
    },
    {
      image: "/images/image-2.jpg",
      alt: "پاستا سیر",
    },
    {
      image: "/images/image-3.png",
      alt: "میوه و ماست",
    },
    {
      image: "/images/image-4.jpg",
      alt: "استیک گوشت",
    },
    {
      image: "/images/image-5.jpg",
      alt: "پیتزا",
    },
    // Add more slides as needed
  ];

  const [showNinja, setShowNinja] = useState(false);
  const handleOpenNinja = () => {
    setShowNinja(true);
  };
  const handleCloseNinja = () => {
    setShowNinja(false);
  };

  return (
    <>
        <div className="grey-background">
      <TopNavbar
        title="خونه"
        rbuttonIcon={["icon-iconmenu"]}
        rbuttonHref={["/menu"]}
        rbackground={["rectangle"]}
        lbuttonIcon={[""]}
        lbuttonHref={["null"]}
        lbackground={["bTransparent"]}
      />

      <div className="main-container">
        <div className="catRow">
          <div>
            <CategoryItem
              imageUrl="/images/categories/fast.png"
              linkTo="/cards"
              title="سریع"
            />
          </div>
          <div>
            {" "}
            <CategoryItem
              imageUrl="/images/categories/economy.png"
              linkTo="/cards"
              title="اقتصادی"
            />
          </div>
          <div>
            {" "}
            <CategoryItem
              imageUrl="/images/categories/vegan.png"
              linkTo="/cards"
              title="گیاهی"
            />
          </div>
          <div>
            {" "}
            <CategoryItem
              imageUrl="/images/categories/party.png"
              linkTo="/cards"
              title="دورهمی"
            />
          </div>
          <div>
            {" "}
            <CategoryItem
              imageUrl="/images/categories/highProtein.png"
              linkTo="/cards"
              title="پروتئینی"
            />
          </div>
          <div>
            {" "}
            <CategoryItem
              imageUrl="/images/categories/breakfast.png"
              linkTo="/cards"
              title="صبحانه"
            />
          </div>
          <div>
            {" "}
            <CategoryItem
              imageUrl="/images/categories/salad.png"
              linkTo="/cards"
              title="سالاد"
            />
          </div>
          <div>
            {" "}
            <CategoryItem
              imageUrl="/images/categories/toast.png"
              linkTo="/cards"
              title="نان تست"
            />
          </div>
          <div>
            {" "}
            <CategoryItem
              imageUrl="/images/categories/mocktail.png"
              linkTo="/cards"
              title="موکتل"
            />
          </div>
          <div>
            {" "}
            <CategoryItem
              imageUrl="/images/categories/shake.png"
              linkTo="/cards"
              title="شیک"
            />
          </div>
          <div>
            {" "}
            <CategoryItem
              imageUrl="/images/categories/smoothie.png"
              linkTo="/cards"
              title="اسموتی"
            />
          </div>
          <div>
            {" "}
            <CategoryItem
              imageUrl="/images/categories/more.png"
              linkTo="/cards"
              title="همه"
            />
          </div>
        </div>
        {/* <Link to="/cards">
          <div className="marginBottom5">
            <Slider slides={slides} />
           </div>
        </Link> */}

        <ChallengeBanner />

        <div>
          <p className="heading-3 rightAlign">برنامه‌های غذایی</p>
          <div className="catRow">
            <div>
              <DietItem
                title="7 نهار پرپروتئین"
                linkTo="/diet"
                imageUrl="/images/diet/protein.png"
              />
            </div>
            <div>
              {" "}
              <DietItem
                title="14 میانوعده سالم"
                linkTo="/diet"
                imageUrl="/images/diet/Snacks14.png"
              />
            </div>
            <div>
              {" "}
              <DietItem
                title="یک هفته وگانیسم!"
                linkTo="/diet"
                imageUrl="/images/diet/Veganism1week.png"
              />
            </div>
            <div>
              {" "}
              <DietItem
                title="7  صبحانه با نان تست"
                linkTo="/diet"
                imageUrl="/images/diet/BreakfastWithToast.png"
              />
            </div>
            <div>
              {" "}
              <DietItem
                title="7 شام با نان تست"
                linkTo="/diet"
                imageUrl="/images/diet/DinnerWithToast.png"
              />
            </div>
          </div>
        </div>
        {/* <DietBanner
          category="برنامه غذایی"
          title="سریع‌ترین راه برنامه‌ریزی غذایی"
          linkTo="/diet"
          imgSrc="/images/dietBanner.png"
        /> */}

        {/* GROCERY LIST BANNERS */}
          <Link to="/grocery">
        <div className="fullBanner">
          <img src="/vectors/vegetables.svg" alt="Grocery List" />
          <p className="big-1">لیست خرید هوشمنـد</p>
          <p className="heading-1">با توجه به غذاهای داخل تقویم!</p>
        </div>
        </Link>

        <NinjaBanner
          title="بگو چی داری، بگم چی درست کنی!"
          img={<NinjaEmoji className="box60" alt="NinjaEmoji"></NinjaEmoji>}
          onClick={handleOpenNinja}
        />

        <div className="spc-between">
          <Link
            to="/tutorialWhy"
            className="purple-1 background-2 spc-between radius2 padding3 width100 hoverAnim"
          >
            <div>
              <p className="big-1 rightAlign">چرا</p>
              <p className="yekan rightAlign">از فودپلنر استفاده کنم؟</p>
            </div>
            <div>
              <p className="big-1">؟</p>
            </div>
          </Link>

          <Link
            to="/tutorialHow"
            className="purple-1 background-2 spc-between radius2 padding3 width100 hoverAnim rightAlign"
          >
            <div>
              <p className="big-1 rightAlign">چجوری</p>
              <p className="yekan rightAlign">از فودپلنر استفاده کنم؟</p>
            </div>
            <div>
              <p className="big-1">!</p>
            </div>
          </Link>
        </div>
        {/* <Link to="/subscription" className=" white">
          <div className="banner4 centerd">
            <div className="spc-between banner3">
              <div>
                <p className="heading-3 paddingTop10">
                  قراره همه چی راحت‌تر بشه!
                </p>
                <p className="yekan caption-1">
                  برنامه غذایی، درست کردن غذا، خرید مواد اولیه و ...
                </p>
                <div className="b-white caption-1 radius1 padding3 centerd marginUpDown20">
                  <p className="gradient-2">اطلاعات بیشتر و فعال کردن</p>
                </div>
              </div>
              <div className="marginTop5">
                <img src={FFF}></img>
              </div>
            </div>
          </div>
        </Link> */}
      </div>
  
</div>
      <Navbar />
      <GoToTop />

      <NinjaModal
        showNinja={showNinja}
        handleOpenNinja={handleOpenNinja}
        handleCloseNinja={handleCloseNinja}
      ></NinjaModal>
    </>
  );
}
